const inkeep_ai_bot = {
    intro_message: "Hi, I'm Logto AI!\n\nI'm an AI assistant trained on documentation, help articles, and other content.\n\nAsk me anything about `Logto`.",
    chat_placeholder: 'Ask Logto AI your question for a step-by-step guide',
    disclaimer_label: 'Logto AI disclaimer',
    disclaimer_tooltip: 'Responses are AI-generated and may require verification.',
    example_questions_label: 'Example questions',
    example_questions: [
        'Quickstart guide for Logto setup',
        'Configure multi-tenancy architecture',
        'How to integrate user profile?',
    ],
    stop: 'Stop',
    clear: 'Start over',
    get_help: 'Get help',
    copy_chat: 'Copy',
    ask_ai_label: 'Ask AI',
    contact: 'Contact',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
